<mat-form-field
  [subscriptSizing]="input.subscriptSizing"
  [appearance]="input.appearance"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="tooltipPosition"
>
  <tb-file-upload
    [formControl]="_formControl"
    [accept]="input.accept ?? []"
    [placeholder]="input.placeholder | parse: context | async"
    [required]="input.required"
  />
  <mat-icon
    [color]="input.color ?? 'accent'"
    fontIcon="file_upload"
    matSuffix
  />
</mat-form-field>
